export default {
  methods: {
      selectImage(image) {
          this.imageUrl = image;
      },
  }
}